import { IResult } from '../types/IResponse';
import { IScheduleDetails } from '../types/ISchedule';
import { Request } from './Request';

// Keep this interface in-sync with ISchedule
export interface IUpdateScheduleParams {
  id: string;
  name: string;
  scheduleType: string; // Hourly, Daily, Weekly, Monthly
  scheduleDetails: IScheduleDetails;
  priority: number;
  parallel: boolean;
}

export class UpdateScheduleRequest extends Request<IUpdateScheduleParams, IResult> {
  constructor(params: IUpdateScheduleParams) {
    super('updateSchedule', params);
  }
}
